module.exports = __webpack_public_path__ + "img/service.97f31cc5.png";